<template>
  <div>
    <BaseNotification
      type="success"
      layout="inline"
      class="mb-6 leading-5"
    >
      <div class="font-semibold mb-5 mt-px">
        {{ title }}
      </div>
      {{ message }}
    </BaseNotification>

    <BaseButton
      color="red"
      size="large"
      class="w-full flex items-center justify-center"
      :href="store.state.leadHubOffer.url"
      @click="trackViewOffer"
    >
      View offer
    </BaseButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import BaseNotification from '@/components/Ui/BaseNotification.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

// grab the store instance
const store = useStore();

// computed values
const title = computed(() => {
  const date = store.state.leadHubOffer.date;
  return `This venue has already sent an offer for your event on ${date}`;
});

const message = computed(() => {
  return 'View the full offer to confirm details, ask questions, or take next steps.';
});

const trackViewOffer = () => {
  store.dispatch('trackGA4Interaction', {
    section: 'lh_offer',
    element: 'view_offer',
    value: null,
    interaction: 'click',
  });
};
</script>
